import type { ReactNode } from 'react'
import { useAuth } from './useAuth'

/**
 * Holds children until the auth session is resolved.
 * Prevents API calls from firing before the bearer token is set in axios,
 * avoiding the 401 race condition on hard reload.
 */
export function SessionGuard({ children }: { children: ReactNode }) {
  const { status } = useAuth()

  if (status === 'loading') {
    return (
      <div className="flex h-full items-center justify-center">
        <svg className="animate-spin h-8 w-8 text-[var(--color-accent)]" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      </div>
    )
  }

  return <>{children}</>
}
